import AbstractRepository from "@/repositories/AbstractRepository";

export default class ListSfFormatRepository extends AbstractRepository {
    protected static resource: string = "ptf-monocle-listdefinition-format";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
    ];
}
